import React, { useState } from 'react';

import moment from 'moment';

import { useGlobal } from '../../../contexts/Global/context';

import Select from '../../../components/Inputs/Select';
import { getListaValoresPlanos } from '../../../services/contrato/contratos';
import DataTableMui from '../../../components/DataTableMui';
import { formatMoney } from '../../../utils/formatValues';

import * as S from './styles';

function TableDadosContrato({ beneficiarySituation }) {
    const { dataActiveContract } = useGlobal();

    const [dataTable, setDataTable] = useState([]);
    const [hideAge, setHideAge] = useState(false);
    const [loading, setLoading] = useState(false);
    const [alreadySearched, setAlreadySearched] = useState(false);

    async function onChangePlan(event) {
        const { value: seletectedPlan } = event;

        if (!seletectedPlan) return;

        setLoading(true);

        const response =
            (await getListaValoresPlanos(dataActiveContract.numero, seletectedPlan, {
                periodoNegociacao:
                    dataActiveContract.dataUltimaVigencia &&
                    moment(dataActiveContract.dataUltimaVigencia, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                situacaoBeneficiario: beneficiarySituation,
            })) || [];

        if(response[0]) setHideAge(response[0].plano.tipo === 'perCapta')

        setLoading(false);

        if (!alreadySearched) setAlreadySearched(true);

        setDataTable(response);
    }

    function createPlanCell({ plano: { codigo, nome, registroAns } }) {
        return (
            <S.PlanCell>
                <label>{nome}</label>
                <span>
                    Cód. {codigo} - Registro ANS: {registroAns}
                </span>
            </S.PlanCell>
        );
    }

    const columnsHead = [
        {
            key: 'plano',
            selector: createPlanCell,
            name: 'Plano',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '35%' }),
        },
        {
            key: 'reajuste',
            selector: (row) => `${row.percentualReajuste}%`,
            name: 'Reajuste',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '13%' }),
        },

        {
            key: 'idade',
            selector: (row) => row.faixaEtaria || '-',
            name: 'Idade',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '13%', height: '60px' }),
            hideColumn: hideAge,
        },
            
        {
            key: 'titular',
            selector: (row) => formatMoney(row.titular),
            name: 'Titular',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '13%', height: '60px' }),
        },
        {
            key: 'dependente',
            selector: (row) => formatMoney(row.dependente),
            name: 'Dependente',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '13%', height: '60px' }),
        },
        {
            key: 'agregado',
            selector: (row) => formatMoney(row.agregado),
            name: 'Agregado',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '13%', height: '60px' }),
        },
    ];

    return (
        <>       
            <S.AlignSelectPlan>
                <Select
                    style={{ maxWidth: '516px' }}
                    field={{
                        id: 'searchField',
                        label: 'Selecione um plano',
                        required: true,
                        options: dataActiveContract.planos,
                    }}
                    onChange={onChangePlan}
                />
            </S.AlignSelectPlan>

            <DataTableMui
                data={dataTable}
                loading={loading}
                columns={columnsHead}
                emptyMessage="Nenhum valor encontrado para o plano selecionado"
                alreadySearched={alreadySearched}
                firstOrderBy="nome"
            />
        </>
    );
}

export default TableDadosContrato;
